import callCmAPI from 'services/helpers/call-cm-api'
import { WebApi2Response } from 'types'
import { toQueryString } from './nordic-lookups-query'

/******************
 * Types          *
 ******************/

// One customer on a 2026 package (RisikaAPI ENG2-2462, via CMAPI ENG2-2464).
export interface NordicCompanyUsage {
  company_id: number
  name: string
  country: string
  local_id: string
  plan: string
  subscription_start: string | null // contract-year anchor (ISO date)
  cap: number | null // 2,147,483,647 = not metered
  used: number // distinct Nordic companies counted this period
  remaining: number | null // never below 0; null when the cap is not a budget
  percent: number | null // integer percent; null when not ratable
  unlimited: boolean
  over_cap: boolean
  period_start: string | null
  period_end: string | null // the count resets here
  days_left: number | null
}

export interface NordicLookupsUsageTotals {
  companies: number
  cap: number // ratable caps only
  used: number
  remaining: number
  unlimited: number // customers left out of the sums
  over_cap: number
}

export interface NordicLookupsUsagePagination {
  page: number
  page_size: number
  total: number
  pages: number
}

export interface NordicLookupsUsageResponse {
  companies: NordicCompanyUsage[]
  totals: NordicLookupsUsageTotals
  // Optional for rollout tolerance, like the Global data usage page.
  pagination?: NordicLookupsUsagePagination
}

export interface NordicLookupsUsageParams {
  page?: number
  pageSize?: number // One of 10, 20, 50, 100
  q?: string // Server-side search on customer name or local id
  sort?: string // -percent (default), -used, -cap, name
}

/******************
 * Fetch from API *
 ******************/

export const getNordicLookupsUsage = (
  params: NordicLookupsUsageParams = {},
): Promise<WebApi2Response<NordicLookupsUsageResponse>> =>
  callCmAPI(
    `/nordic-lookups/usage${toQueryString({
      page: params.page,
      page_size: params.pageSize,
      q: params.q,
      sort: params.sort,
    })}`,
    { method: 'get' },
  )
    .then((res) => ({
      success: true as const,
      data: res.data as NordicLookupsUsageResponse,
    }))
    .catch((err) => ({ success: false as const, data: null, error: err }))
